import { render, staticRenderFns } from "./BeusDocentHistoryList.vue?vue&type=template&id=092d08f7&scoped=true"
import script from "./BeusDocentHistoryList.vue?vue&type=script&lang=js"
export * from "./BeusDocentHistoryList.vue?vue&type=script&lang=js"
import style0 from "./BeusDocentHistoryList.vue?vue&type=style&index=0&id=092d08f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092d08f7",
  null
  
)

export default component.exports